<div class="resent-otp-wrapper">

	<div class="title">
		<ng-container *ngIf="otpResendVersion2 else defaultTitle">
			Resend Code
			<p class="text-[12px] font-medium text-[#808080]">Choose how to send code to {{maskedPhoneNumber}}</p>
		</ng-container>
		<ng-template #defaultTitle>
			Resend OTP
		</ng-template>
	</div>
	<div class="modal-list">
		<ng-container *ngIf="otpResendVersion2 else defaultOrder">
			<ng-container *ngIf="canUseUssdOTPResend">
				<ng-container *ngTemplateOutlet="phoneOptionV2"></ng-container>
			</ng-container>
			<ng-container *ngIf="canUseWhatsappOTPResend">
				<ng-container *ngTemplateOutlet="sendOtpViaWhatsapp"></ng-container>
			</ng-container>
			<ng-container *ngIf="canUseSmsOTPResend">
				<ng-container *ngTemplateOutlet="sendOtpViaSms"></ng-container>
			</ng-container>
		</ng-container>
		<ng-template #defaultOrder>
			<ng-container *ngIf="canUseUssdOTPResend">
				<ng-container *ngTemplateOutlet="phoneOption"></ng-container>
			</ng-container>
			<ng-container *ngIf="canUseSmsOTPResend">
				<ng-container *ngTemplateOutlet="smsOption"></ng-container>
			</ng-container>
			<ng-container *ngIf="canUseWhatsappOTPResend">
				<ng-container *ngTemplateOutlet="whatsappOption"></ng-container>
			</ng-container>
		</ng-template>
	</div>

	<div class="mt-[16px]">
		<div class="pt-[24px]">
			<div (click)="closeModal()"
				class="bg-[#E6EEFD] h-[48px] max-w-[335px] mx-auto items-center cursor-pointer rounded-[8px] py-[6px] px-[16px] flex justify-center">
				<div class="leading-[17.36px] text-[14px] text-[#0361F0] font-medium">
					Dismiss
				</div>
			</div>
		</div>
	</div>
</div>

<!-- phone option -->

<ng-template #phoneOption>
	<div [ngClass]="{'opacity-60':currentMode === OtpResentMode.USSD_MODE}" class="list" (click)="resendOTPViaUssd()">
		<div>
			<img src="assets/images/svgs/otp-number-pad.svg">
		</div>
		<div class="subtitle">
			<div class="flex flex-col">
				<div class="flex gap-[4px] font-bold">
					<div class="text-black">Dial</div>
					<div class="text-[#0361F0]">{{ussdCode}}</div>
				</div>
				<div class="flex text-[12px] gap-[4px]">
					<div class="font-medium text-[#808080]">From phone number</div>
					<div class="font-bold text-[#4D4D4D]">{{maskedPhoneNumber}}</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #phoneOptionV2>
	<div [ngClass]="{'opacity-60':currentMode === OtpResentMode.USSD_MODE}" class="list" (click)="resendOTPViaUssd()">
		<div>
			<img src="assets/images/svgs/otp-number-pad.svg">
		</div>
		<div class="subtitle">

			<div class="flex gap-[4px] font-bold">
				<div class="text-black">Dial</div>
				<div class="text-[#0361F0]">{{ussdCode}}</div>
			</div>
			<div class="text-[11px] font-medium text-[#808080]">Tap here or dial on your phone</div>
		</div>
		<span class="p-1 bg-[#E6EEFD] text-[#0361F0] text-[10px] rounded-md ml-auto font-semibold">
			Recommended
		</span>
	</div>
</ng-template>


<!-- sms option -->

<ng-template #smsOption>
	<ng-container *ngIf="isSmsCountdown else sendOtpViaSms">
		<div class="list">
			<div>
				<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect y="0.5" width="36" height="36" rx="8" fill="#F3F5F8" />
					<path
						d="M24.8747 11H11.1247C10.5171 11.0006 9.93457 11.2383 9.50494 11.6608C9.07531 12.0834 8.83366 12.6562 8.83301 13.2538V22.9129C8.83366 23.5104 9.07531 24.0833 9.50494 24.5058C9.93457 24.9284 10.5171 25.166 11.1247 25.1667H24.8747C25.4823 25.166 26.0648 24.9284 26.4944 24.5058C26.924 24.0833 27.1657 23.5104 27.1663 22.9129V13.2538C27.1657 12.6562 26.924 12.0834 26.4944 11.6608C26.0648 11.2383 25.4823 11.0006 24.8747 11ZM24.2944 14.728L18.4015 19.2356C18.2866 19.3234 18.1452 19.3711 17.9997 19.3711C17.8541 19.3711 17.7127 19.3234 17.5978 19.2356L11.705 14.728C11.6357 14.6766 11.5776 14.6121 11.5339 14.5384C11.4902 14.4647 11.4618 14.3832 11.4504 14.2986C11.4391 14.214 11.4449 14.128 11.4676 14.0457C11.4903 13.9633 11.5294 13.8862 11.5826 13.8189C11.6359 13.7515 11.7022 13.6952 11.7778 13.6533C11.8534 13.6114 11.9366 13.5846 12.0228 13.5746C12.109 13.5646 12.1963 13.5716 12.2797 13.595C12.3631 13.6185 12.4409 13.6581 12.5087 13.7114L17.9997 17.9115L23.4907 13.7114C23.628 13.6094 23.8006 13.5647 23.9711 13.5869C24.1417 13.6091 24.2966 13.6964 24.4022 13.83C24.5078 13.9636 24.5557 14.1327 24.5355 14.3007C24.5153 14.4688 24.4287 14.6223 24.2944 14.728Z"
						fill="#6C84AC" />
				</svg>
			</div>
			<div class="flex subtitle">
				<div class="text-black/60">
					Send via SMS in
				</div>
				<div class="text-[#0361F0]">
					<ng-container *ngIf="!loading">
						<ng-container *ngTemplateOutlet="countdownTemplate; context:{countdownData : smsCountdown}">
						</ng-container>
					</ng-container>
					<ng-container *ngIf="loading">
						<app-kamona-loading [size]="20" [parentHeight]="'0'">
						</app-kamona-loading>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #sendOtpViaSms>
	<div class="list" (click)="resendOtpViaSMS()">
		<div>
			<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect y="0.5" width="36" height="36" rx="8" fill="#F2F7FE" />
				<path
					d="M24.8747 11H11.1247C10.5171 11.0006 9.93457 11.2383 9.50494 11.6608C9.07531 12.0834 8.83366 12.6562 8.83301 13.2538V22.9129C8.83366 23.5104 9.07531 24.0833 9.50494 24.5058C9.93457 24.9284 10.5171 25.166 11.1247 25.1667H24.8747C25.4823 25.166 26.0648 24.9284 26.4944 24.5058C26.924 24.0833 27.1657 23.5104 27.1663 22.9129V13.2538C27.1657 12.6562 26.924 12.0834 26.4944 11.6608C26.0648 11.2383 25.4823 11.0006 24.8747 11ZM24.2944 14.728L18.4015 19.2356C18.2866 19.3234 18.1452 19.3711 17.9997 19.3711C17.8541 19.3711 17.7127 19.3234 17.5978 19.2356L11.705 14.728C11.6357 14.6766 11.5776 14.6121 11.5339 14.5384C11.4902 14.4647 11.4618 14.3832 11.4504 14.2986C11.4391 14.214 11.4449 14.128 11.4676 14.0457C11.4903 13.9633 11.5294 13.8862 11.5826 13.8189C11.6359 13.7515 11.7022 13.6952 11.7778 13.6533C11.8534 13.6114 11.9366 13.5846 12.0228 13.5746C12.109 13.5646 12.1963 13.5716 12.2797 13.595C12.3631 13.6185 12.4409 13.6581 12.5087 13.7114L17.9997 17.9115L23.4907 13.7114C23.628 13.6094 23.8006 13.5647 23.9711 13.5869C24.1417 13.6091 24.2966 13.6964 24.4022 13.83C24.5078 13.9636 24.5557 14.1327 24.5355 14.3007C24.5153 14.4688 24.4287 14.6223 24.2944 14.728Z"
					fill="#0361F0" />
			</svg>
		</div>
		<div class="subtitle">
			Send Via SMS
		</div>
	</div>
</ng-template>

<!-- whatsapp option -->
<ng-template #whatsappOption>
	<ng-container *ngIf="isWhatsAppCountdown else sendOtpViaWhatsapp">
		<div class="list">
			<div>
				<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect y="0.5" width="36" height="36" rx="8" fill="#F2F7FE" />
					<path
						d="M18.0003 10.7004C13.8635 10.7004 10.5006 14.0664 10.5006 18.2004C10.5006 19.5774 10.8756 20.9184 11.5896 22.0884L10.5156 25.3074C10.4796 25.4154 10.5067 25.5324 10.5876 25.6134C10.6446 25.6704 10.7226 25.7004 10.8006 25.7004C10.8336 25.7004 10.8636 25.6974 10.8966 25.6854L14.1125 24.6144C15.2854 25.3254 16.6264 25.7004 18.0003 25.7004C22.1371 25.7004 25.5 22.3375 25.5 18.2004C25.5 14.0664 22.1371 10.7004 18.0003 10.7004ZM22.8001 21.2364C22.8001 21.4974 22.6921 21.7555 22.5061 21.9414L21.7261 22.7125C21.5401 22.8984 21.2882 23.0004 21.0302 23.0004H20.9912C16.8004 22.8204 13.3805 19.4004 13.2005 15.2125C13.1885 14.9394 13.2935 14.6694 13.4885 14.4744L14.2595 13.6944C14.4455 13.5084 14.7035 13.4004 14.9674 13.4004H15.2554C15.6664 13.4004 16.0414 13.6584 16.1854 14.0454L16.8694 15.8604C17.0013 16.2144 16.9204 16.6194 16.6594 16.8954L16.3774 17.1924C16.2484 17.3274 16.2334 17.5344 16.3384 17.6875C16.6864 18.1914 17.4303 19.1424 18.5163 19.8744C18.6663 19.9734 18.8703 19.9555 19.0023 19.8294L19.3082 19.5414C19.5812 19.2805 19.9862 19.1994 20.3402 19.3314L22.1551 20.0154C22.5421 20.1625 22.8001 20.5344 22.8001 20.9454V21.2364Z"
						fill="#6C84AC" />
				</svg>
			</div>
			<div class="flex subtitle">
				<div class="text-black/60">
					Send via Whatsapp
				</div>
				<div *ngIf="whatsappCountdown" class="text-[#0361F0]">
					<ng-container *ngIf="!loading">
						<ng-container
							*ngTemplateOutlet="countdownTemplate; context:{countdownData : whatsappCountdown}">
						</ng-container>
					</ng-container>
					<ng-container *ngIf="loading">
						<app-kamona-loading [size]="20" [parentHeight]="'0'">
						</app-kamona-loading>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #sendOtpViaWhatsapp>

	<div (click)="resendOtpViaWhatsApp()" class="list">
		<div>
			<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect y="0.5" width="36" height="36" rx="8" fill="#F2F7FE" />
				<path
					d="M18.0003 10.7004C13.8635 10.7004 10.5006 14.0664 10.5006 18.2004C10.5006 19.5774 10.8756 20.9184 11.5896 22.0884L10.5156 25.3074C10.4796 25.4154 10.5067 25.5324 10.5876 25.6134C10.6446 25.6704 10.7226 25.7004 10.8006 25.7004C10.8336 25.7004 10.8636 25.6974 10.8966 25.6854L14.1125 24.6144C15.2854 25.3254 16.6264 25.7004 18.0003 25.7004C22.1371 25.7004 25.5 22.3375 25.5 18.2004C25.5 14.0664 22.1371 10.7004 18.0003 10.7004ZM22.8001 21.2364C22.8001 21.4974 22.6921 21.7555 22.5061 21.9414L21.7261 22.7125C21.5401 22.8984 21.2882 23.0004 21.0302 23.0004H20.9912C16.8004 22.8204 13.3805 19.4004 13.2005 15.2125C13.1885 14.9394 13.2935 14.6694 13.4885 14.4744L14.2595 13.6944C14.4455 13.5084 14.7035 13.4004 14.9674 13.4004H15.2554C15.6664 13.4004 16.0414 13.6584 16.1854 14.0454L16.8694 15.8604C17.0013 16.2144 16.9204 16.6194 16.6594 16.8954L16.3774 17.1924C16.2484 17.3274 16.2334 17.5344 16.3384 17.6875C16.6864 18.1914 17.4303 19.1424 18.5163 19.8744C18.6663 19.9734 18.8703 19.9555 19.0023 19.8294L19.3082 19.5414C19.5812 19.2805 19.9862 19.1994 20.3402 19.3314L22.1551 20.0154C22.5421 20.1625 22.8001 20.5344 22.8001 20.9454V21.2364Z"
					fill="#0361F0" />
			</svg>
		</div>
		<div class="subtitle">
			Send via Whatsapp
		</div>
	</div>
</ng-template>

<ng-template #countdownTemplate let-countdownData="countdownData">
	<div class="flex pl-[3px]">
		<div>
			{{formatTime(countdownData?.minute)}}
		</div>
		<div>:</div>
		<div>
			{{formatTime(countdownData?.second)}}
		</div>
	</div>
</ng-template>
